/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import './Processbar.scss';
import { appBgColor, appChipStyle, appIcons, appIconsPath } from '@utils/globalConstant';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { ChipTariffBadge, Ta11yText } from '@core/index';
import { useActivation } from '@context/MobileOne';
import { tA11y, replaceDynamicCmsContent } from '@utils/a11y/a11yHelpers';
import { sanitizeRichText } from '@utils/sanitizeHtml';
import { useA11y } from '@context/Utils/A11y';
import Icons from '@core/Utils/Icons/Icons';
import { useStaticContent } from '@context/StaticContent';

export function Processbar() {
  // Context
  const {
    currentStep,
    prevStep,
    tariffActivationForm,
    step3SubStep,
    setStep3SubStep,
    step7SubStep,
    setStep7SubStep,
    step9SubStep,
    setStep9SubStep,
    phoneNumberActivationForm,
    withMNP
  } = useActivation();
  const { tA11yTranslate } = useA11y();
  const { staticContentData } = useStaticContent();

  let stripeTextContent = {};

  stripeTextContent = tA11y('ek_reg_progress_msisdn');
  if (withMNP) {
    stripeTextContent = replaceDynamicCmsContent(
      stripeTextContent,
      '{MSISDN}',
      phoneNumberActivationForm.oldNumberComplete
    );
  } else {
    stripeTextContent = replaceDynamicCmsContent(
      stripeTextContent,
      '{MSISDN}',
      phoneNumberActivationForm.msisdn
    );
  }

  const stepTextContent = tA11yTranslate('ek_reg_nav_step');
  const stepOfTextContent = tA11yTranslate('ek_reg_nav_step_of');

  // State
  const totalSteps = 9;
  const [title, setTitle] = useState('Heading');
  const [showIcon, setShowIcon] = useState(false);
  const [chipTariffBadge, setChipTariffBadge] = useState(false);
  const [chipStyle, setChipStyle] = useState(null);
  const [chipIcon, setChipIcon] = useState(null);
  const [showStripe, setShowStripe] = useState(false);
  // const [stripeText, setStripeText] = useState('');

  // function
  const onIconClick = () => {
    if (step9SubStep === 3) {
      setStep9SubStep(2);
      return;
    }
    if (step9SubStep === 2) {
      setStep9SubStep(0);
      return;
    }
    if (step7SubStep === 1) {
      setStep7SubStep(0);
      return;
    }
    if (step3SubStep === 1) {
      setStep3SubStep(0);
      return;
    }
    prevStep();
  };

  // Hooks
  useEffect(() => {
    switch (currentStep) {
      case 1:
        setTitle('ek_reg_sim-data_page_title');
        setShowIcon(false);
        break;

      case 2:
        setTitle('ek_reg_tariff_page_title');
        setShowIcon(false);
        setChipTariffBadge(false);
        break;

      case 3:
        setTitle('ek_reg_mnp_page_title');
        setChipTariffBadge(true);
        setChipStyle(appChipStyle[tariffActivationForm.chosenTariffId]);
        setChipIcon(appIconsPath.ESIM);
        if (step3SubStep === 1) {
          setShowIcon(true);
        } else {
          setShowIcon(false);
        }
        setShowStripe(false);
        break;

      case 4:
        setTitle('ek_reg_voucher_page-title');
        setChipTariffBadge(true);
        setChipStyle(appChipStyle[tariffActivationForm.chosenTariffId]);
        setChipIcon(appIconsPath.ESIM);
        setShowStripe(true);
        // setStripeText(phoneNumberActivationForm.msisdn);
        setShowIcon(false);
        break;

      case 5:
        setTitle('ek_reg_page-title');
        setChipTariffBadge(true);
        setChipStyle(appChipStyle[tariffActivationForm.chosenTariffId]);
        setChipIcon(appIconsPath.ESIM);
        setShowStripe(true);
        // setStripeText(phoneNumberActivationForm.msisdn);
        setShowIcon(false);
        break;

      case 6:
        setTitle('ek_reg_legi_page_title');
        setChipTariffBadge(true);
        setChipStyle(appChipStyle[tariffActivationForm.chosenTariffId]);
        setChipIcon(appIconsPath.ESIM);
        setShowStripe(true);
        // setStripeText(phoneNumberActivationForm.msisdn);
        setShowIcon(false);
        break;

      case 7:
        setTitle('ek_reg_prsnl_page_title');
        setChipTariffBadge(true);
        setChipStyle(appChipStyle[tariffActivationForm.chosenTariffId]);
        setChipIcon(appIconsPath.ESIM);
        setShowStripe(true);
        // setStripeText(phoneNumberActivationForm.msisdn);
        setShowIcon(true);
        if (step7SubStep === 1) {
          setShowIcon(true);
        } else {
          setShowIcon(false);
        }
        break;

      case 8:
        setTitle('ek_reg_autotopup_page_title');
        setChipTariffBadge(true);
        setChipStyle(appChipStyle[tariffActivationForm.chosenTariffId]);
        setChipIcon(appIconsPath.ESIM);
        setShowIcon(false);
        setShowStripe(true);
        break;

      case 9:
        setTitle('ek_reg_summary_page_title');
        setChipTariffBadge(true);
        setChipStyle(appChipStyle[tariffActivationForm.chosenTariffId]);
        setChipIcon(appIconsPath.ESIM);
        if (step9SubStep === 0 || step9SubStep === 1) {
          setShowIcon(false);
        } else {
          setShowIcon(true);
        }
        setShowStripe(true);
        break;

      default:
        setTitle('');
        setShowIcon(false);
        break;
    }
  }, [currentStep, step3SubStep, step7SubStep, step9SubStep, tariffActivationForm]);

  const getSpeedName = (tariffId) => {
    const tariff = staticContentData?.ek_tariff?.find((t) => t.id === tariffId);
    return tariff ? tariff.nameSpeed : '';
  };

  return (
    <div className="shadow-lg">
      <AppPageContentWrapper bgColor={appBgColor.DEFAULT_GRADIENT} isDefaultPadding={false}>
        <div className="pt-64 pb-24">
          <div className="mt-20 mb-16 space-24 d-flex justify-content-between align-items-center">
            {showIcon && (
              <div
                role="button"
                tabIndex={0}
                onClick={onIconClick}
                aria-label={tA11yTranslate('ek_global_icn-back_aria').ariaLabel}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onIconClick();
                  }
                }}>
                <Icons name="ARROW_BACK" colorType="dark" height={24} />
              </div>
            )}
            {/* {console.log(tariffActivationForm, "tariffActivationForm")} */}
            {chipTariffBadge && (
              <div className="ms-auto">
                <ChipTariffBadge
                  chipStyle={chipStyle}
                  icon={chipIcon}
                  label={tariffActivationForm?.chosenTariffName}
                  speedName={getSpeedName(tariffActivationForm?.chosenTariffId)}
                />
              </div>
            )}
          </div>
          <div>
            <div className="d-flex justify-content-between align-items-center">
              {tA11y(title).isHtml ? (
                <h1
                  className="ek-copy-16-semibold text-wrap mb-0"
                  dangerouslySetInnerHTML={{ __html: sanitizeRichText(tA11y(title).content) }}
                />
              ) : (
                <h1 className="ek-copy-16-semibold text-wrap mb-0">{tA11y(title).content}</h1>
              )}
              {/* BFSG: add aria-labels */}
              <div
                className="ek-copy-sm-14-medium"
                aria-label={`${stepTextContent?.ariaLabel} ${currentStep} ${stepOfTextContent?.ariaLabel} ${totalSteps}`}>
                <span aria-hidden="true">
                  {currentStep}/{totalSteps}
                </span>
              </div>
            </div>
            <div className="row m-0 gap-10 pt-10">
              {[...Array(totalSteps)].map((_, index) => {
                const step = index + 1;
                return (
                  <div
                    key={step}
                    className={`col space-4 rounded-1 ${
                      currentStep >= step ? 'bg-primary' : 'bg-white'
                    }`}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </AppPageContentWrapper>
      <AppPageContentWrapper bgColor={appBgColor.SECONDARY} isDefaultPadding={false}>
        {showStripe && (
          <div className="d-flex align-items-center py-10">
            <Ta11yText
              tag="p"
              textContent={stripeTextContent}
              className="ek-copy-sm-14-medium text-wrap"
            />
          </div>
        )}
      </AppPageContentWrapper>
    </div>
  );
}

export default Processbar;
